/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47895Item {
  
  /** 执行人用户id */
  userId?: string;
  
  /** 执行人姓名 */
  userName?: string;
  
  /** 头像 */
  userLogo?: string;
  
  /** 用户状态(NORMAL:正常,DISABLE:禁用,RESIGN:离职),详见UserStatusEnum */
  userStatus?: string;
  
};
    
  



export interface API47895Req {
  
  /** 任务id */
  taskId?: string;
    
};



export interface API47895Res {
  /** task_id  */
  taskId?: number;
  /** task_id  */
  id?: number;
  /** 项目编号  */
  projectNo?: string;
  /** 项目计划编号  */
  planNo?: string;
  /** 任务标题  */
  taskTitle?: string;
  /** 任务描述  */
  taskDesc?: string;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre>  */
  taskStatus?: number;
  /** 任务完成标准(1:或签,2:会签，默认1)，详见TaskCompleteTypeEnum  */
  taskCompleteType?: number;
  /** 计划开始时间  */
  startTime?: any;
  /** 计划完成时间  */
  endTime?: any;
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum  */
  taskPriority?: number;
  /** 任务创建人发起人  */
  creator?: string;
  /** 任务创建人姓名  */
  creatorName?: string;
  /** 头像  */
  creatorLogo?: string;
  /** 任务负责人部门id  */
  orgId?: string;
  /** 执行人列表 ,UserInfo  */
  taskExecutorList?: API47895Item[];
  /** 任务反馈列表 ,WorkTaskFeedbackResult  */
  feedbackList?: API47895Item[];
  /** 能否处理已逾期的任务  */
  canExecOverdue?: boolean;
  /** 抄送人 ,UserInfo  */
  workTaskCcList?: API47895Item[];
  /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),详见BizDomainEnum  */
  bizDomain?: number;
  
};


// 47895 任务详情

export interface IUseGetAPI47895Return {
  /** 任务详情: 接口请求状态 */
  isAPI47895Loading: boolean;
  /** 任务详情: 接口请求返回数据 */
  dataAPI47895: API47895Res;
  /**  任务详情: 接口数据请求方法 */
  fetchAPI47895Data:  (inputs: API47895Req, config?: YWRequestConfig) => Promise<API47895Res>;
  /** 任务详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47895 = ():IUseGetAPI47895Return => {
  let isMount = true;
  const [isAPI47895Loading, setIsAPI47895Loading] = useState(false);
  const [dataAPI47895, setDataAPI47895] = useState<API47895Res>({} as API47895Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/detail`;

  const fetchAPI47895Data = async (inputs: API47895Req, config?: YWRequestConfig): Promise<API47895Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47895Req>) || {}) as API47895Req;
    
  
    if ( isMount ) {
      setIsAPI47895Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47895Res>(`${basePath}/corp-admin/project/plan/task/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47895(res || {} as API47895Res);
        setIsAPI47895Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47895Loading(false);
      }
      return false as unknown as API47895Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47895Loading,
    dataAPI47895,
    fetchAPI47895Data,
    requestUrl,
  }
}

